import React from 'react'
import { Divider } from '../../components/divider'

export const Eligibility = () => {
  return (
    <div>
      <h1 className="ds-u-font-size--h2">Check your eligibility</h1>
      <p>
        HHS-OIG processes only those whistleblower complaints that fall within
        its jurisdiction and meet certain requirements. Protected whistleblowers
        are those who have exposed fraud, waste, abuse, mismanagement or
        unlawful activity within a HHS agency, contractor, subcontractor,
        grantee or subgrantee organization, and the law prohibits employers from
        taking retaliatory actions against them.
      </p>
      <p>
        Below is information that HHS-OIG looks for when evaluating the
        eligibility of a whistleblower retaliation complaint.
      </p>
      <Divider />
      <h2 className="ds-u-font-size--h3">Who do you work for?</h2>
      <p>
        To file a whistleblower retaliation complaint with HHS OIG, you must be
        a Federal employee or applicant for HHS or one of its agencies. Or, you
        must work for a non-federal employer that receives HHS contract or grant
        funding.
      </p>
      <h3 className="ds-u-font-size--h4">Who is eligible?</h3>
      <p>Examples of those who meet the eligibility criteria include:</p>
      <ul>
        <li>HHS Employees or applicants for HHS employment or its agencies</li>
        <li>HHS contractors or subcontractors</li>
        <li>Grantees for an HHS program</li>
        <li>U.S. Public Health Service Commissioned Corps officers</li>
      </ul>
      <h3 className="ds-u-font-size--h4">Who is not eligible?</h3>
      <p>Examples of those who are not eligible include:</p>
      <ul>
        <li>Employees of non-HHS Federal agencies</li>
        <li>State or local government employees</li>
        <li>
          Healthcare providers who are not employed by HHS contractors or
          grantees (Medicare / Medicaid provider agreements are not HHS
          contracts)
        </li>
        <li>Medicare or Medicaid beneficiaries</li>
        <li>Insurance beneficiaries</li>
        <li>Patients</li>
      </ul>
      <Divider />
      <h2 className="ds-u-font-size--h3">
        Did you submit a protected communication?
      </h2>
      <p>
        A protected communication occurs when an employee discloses fraud,
        waste, abuse or mismanagement to a person with supervisory authority
        over the employee, the Inspector General, the Comptroller General, the
        Office of Special Counsel, a member of Congress, a state or federal
        regulatory or law enforcement agency, a court or grand jury, the head of
        a federal agency or his/her representatives, or individuals responsible
        for the management of a contract or grant (e.g., contracting officer).
      </p>
      <Divider />
      <h2 className="ds-u-font-size--h3">Were you retaliated against?</h2>
      <p>
        Your employer cannot take action against you for disclosing wrongdoing.
        Examples of actions that could be considered retaliatory include:
      </p>
      <ul>
        <li>Poor performance reviews</li>
        <li>Demotion or termination</li>
        <li>Denial of training or travel</li>
        <li>
          Reassignments or assignments to duties inappropriate for one’s grade
          level
        </li>
        <li>Failure to promote or appoint to a position</li>
        <li>Denial of benefits or telework</li>
        <li>Retaliatory investigations</li>
        <li>Other adverse personnel actions</li>
      </ul>
    </div>
  )
}
